import { ModalFooter } from '@fiverr-private/overlay';

export default ModalFooter;
